import React from "react";
import { Spinner } from "reactstrap";

const FullLoader = () => {
  return (
    <div className="d-flex w-100 h-100 bg-white justify-content-center align-items-center fixed-top">
      <Spinner color="primary" style={{ width: "5rem", height: "5rem" }} />
    </div>
  );
};

export default FullLoader;
